import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import vueQr from 'vue-qr';
import './assets/icon/iconfont.css'
import './assets/icon/iconfont.svg'


import websdk from "easemob-websdk"
import webimconfig from './config/webim.js'
// 环信
let WebIM = window.WebIM = websdk;
WebIM.config = webimconfig;
// 环信实例
var conn = WebIM.conn = new WebIM.connection({
	appKey: WebIM.config.appkey,
	isHttpDNS: WebIM.config.isHttpDNS,
	isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
	https: WebIM.config.https,
	url: WebIM.config.xmppURL,
	apiUrl: WebIM.config.apiURL,
	isAutoLogin: true,
	heartBeatWait: WebIM.config.heartBeatWait,
	autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
	autoReconnectInterval: WebIM.config.autoReconnectInterval,
	isStropheLog: WebIM.config.isStropheLog,
	delivery: WebIM.config.delivery
})
// 账号密码登录配置
var optionsIm = {
	apiUrl: WebIM.config.apiURL,
	user: 'user02', //换成自己申请的账号就行，密码也需要换  
	pwd: '123',
	appKey: WebIM.config.appkey,
	success: function(re) {
		console.log('登陆成功')
	},
	error: function(err) {
		console.log(err)
	}
}
Vue.prototype.$WebIM = WebIM;
Vue.prototype.$imconn = conn
Vue.prototype.$imoption = optionsIm;


// ahaapi
import util from 'ahaapi';
// 后端接口列表
import api from '../commen/api.js';
// 全局常量

import commen from '../commen/commen.js';


// 全局引用
Vue.prototype.$api = api;
Vue.prototype.$util = util;
Vue.prototype.$commen = commen;

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(vueQr);
new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
